(function() {

    const WIDGET_TAG = 'recharge-subscription-widget';

    // 1. Obtener ID de variante (con conversión a número por si acaso)
    function getCurrentVariantId() {
        const formInput = document.querySelector('form[action^="/cart/add"] [name="id"]');
        return formInput ? formInput.value : new URLSearchParams(window.location.search).get('variant');
    }

    // 2. Función "Fantasma" (Entra al Shadow DOM)
    function shadowUpdate(variantId) {
        if (!variantId) return;

        const widget = document.querySelector(WIDGET_TAG);
        if (!widget) return;

        // Si widget.shadowRoot es null, intentamos usar el widget directo (fallback)
        const root = widget.shadowRoot || widget;

        // A. Actualizamos atributos lógicos (para que el botón de compra funcione)
        const currentAttr = widget.getAttribute('variant-id');
        if (currentAttr !== variantId) {
            widget.setAttribute('variant-id', variantId);
            widget.setAttribute('default-variant-id', variantId);
            
            // Actualizar URL
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('variant', variantId);
            window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
        }

        // B. Inyectar Precios Visualmente
        // Convertimos variantId a String para buscar en el objeto, pero ten en cuenta 
        // que a veces las llaves del objeto de config son numéricas.
        if (window.SubscriptionWidgetConfig && 
            window.SubscriptionWidgetConfig.formattedPrices) {
            
            // Buscamos el precio. Probamos como string y como número por si acaso.
            const prices = window.SubscriptionWidgetConfig.formattedPrices[variantId] || 
                           window.SubscriptionWidgetConfig.formattedPrices[Number(variantId)];

            if (prices) {
                console.log('found prices for', variantId, prices);
                
                // --- SELECTORES DENTRO DEL SHADOW DOM ---
                
                // 1. Precio Tachado (Original)
                // Buscamos por atributo 'part' que es lo más seguro en componentes modernos
                const strikePrice = root.querySelector('[part*="original-price"]');
                if (strikePrice) {
                    strikePrice.innerText = prices.unit; // ej: $138.32
                    strikePrice.style.display = 'inline-block'; // Asegurar visibilidad
                }

                // 2. Precio con Descuento (Discounted)
                const discountPrice = root.querySelector('[part*="discounted-price"]');
                if (discountPrice) {
                    // A veces hay nodos de texto ocultos, usamos textContent para limpiar
                    discountPrice.textContent = prices.discounted; // ej: $117.57
                }

                // 3. Precio One-time (Compra única)
                // A veces este tiene el part="rc-purchase-option__price"
                const oneTimePrice = root.querySelector('[part="rc-purchase-option__price"]');
                if (oneTimePrice) {
                    oneTimePrice.textContent = prices.unit;
                }

            } else {
                console.log('⚠️ No hay precios en config para la variante:', variantId);
            }
        }
    }

    // 3. Listeners
    document.addEventListener('change', (e) => {
        if (e.target.closest('form[action^="/cart/add"]') || e.target.closest('.product-form')) {
            // Un pequeño timeout para asegurar que el componente no se re-renderice sobre nosotros
            setTimeout(() => shadowUpdate(getCurrentVariantId()), 50);
        }
    });

    document.addEventListener('click', (e) => {
        if (e.target.closest('[data-value], .radio__button, .swatch-element, label')) {
            setTimeout(() => shadowUpdate(getCurrentVariantId()), 100);
        }
    });

    // Ejecutar al inicio
    document.addEventListener('DOMContentLoaded', () => {
        const startId = getCurrentVariantId();
        if(startId) shadowUpdate(startId);
    });

})();